"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackClickProviderComCta = void 0;
const enums_1 = require("../enums");
const trackGA4EventWithCleanUp_1 = require("./trackGA4EventWithCleanUp");
const trackClickProviderComCta = (clickText, clickElement, bookingType) => {
    const bookingEvent = {
        event: 'JS_Event',
        eventData: {
            eventName: enums_1.GA4EventName.ClickEcomCta,
            feature_category: enums_1.GA4FeatureCategory.ProviderList,
            click_text: clickText,
            click_element: clickElement,
            booking_type: bookingType,
        },
    };
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)(bookingEvent);
};
exports.trackClickProviderComCta = trackClickProviderComCta;
//# sourceMappingURL=trackClickProviderComCta.js.map